//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionMoveToFolderFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22 4H12.47L11.21 2.5H2V20H22V4ZM14.95 16H12.34L14.86 13H6V11H14.85L12.33 8H14.94L18.3 12L14.95 16Z" fill="currentColor" /></svg>;
}
export default IconActionMoveToFolderFill;